var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"kyc-chart-precision"},[_vm._v(_vm._s(_vm.$tf('precision'))+": "+_vm._s(_vm.$tt.apply(void 0, _vm.precisionLocaleStrings)))])}
var staticRenderFns = []

export { render, staticRenderFns }